<template>
  <div :class="{ 'c-form__floatinglabels': floating }">
    <div
      class="form-group"
      :class="{ 'form-inline': inline, shortanswer: floating }"
    >
      <label :for="codename">{{ Label }}</label>
      <select
        :id="codename"
        :value="value"
        class="form-control custom-select custom-select-sm custom-select-white"
        :class="{
          'input-validation-error': validation && validation.$error,
          'input-validation-success':
            validation && validation.$anyDirty && !validation.$invalid,
        }"
        :disabled="disabled"
        @change="$emit('input', $event.target.value)"
      >
        <option
          v-for="option in options"
          :key="option.value"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select>
      <span
        v-if="validation && validation.$error"
        class="help-validation-error"
      >
        <font-awesome-icon :icon="['fas', 'exclamation-circle']" />
        <span
          v-if="required && !validation.required"
        >Dit veld is verplicht</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    inline: {
      type: Boolean,
      required: false,
      placeholder: true
    },
    value: {
      type: String,
      required: true
    },
    codename: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    validation: {
      type: Object,
      default: () => {}
    },
    floating: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    Label() {
      return this.required ? this.label + ' *' : this.label;
    },
    required() {
      return this.validation && this.validation.$params
        ? Object.values(this.validation.$params).some(
            (validation) => validation.type === 'required'
          )
        : false;
    }
  }
};
</script>
